import { isoZ, z } from 'my-zod'

export const vehicleWarrantiesModel = z.object({
  id: z.string().min(1).uuid(),
  shortId: z.string().max(12),
  vehicleId: z.number(),
  type: z.string().max(50).nullable(), // "Basic", "Powertrain", "EFW" "ESC"
  coverageType: z.string().max(50).nullable(),
  typeDescription: z.string().max(50).nullable(),
  warrantyStartDate: isoZ.date().nullable(),
  warrantyEndDate: isoZ.date().nullable(),
  lastWarrantyCheckDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type vehicleWarrantiesModel = z.infer<typeof vehicleWarrantiesModel>
